import { useEffect } from "react";

// Simple SEO helper without needing HelmetProvider wrapper for entire tree
export function SEO({ title, description, image, url, type = "article", canonical, jsonLd }) {
  useEffect(() => {
    const set = (selector, attr, value) => {
      if (!value) return;
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const [tag, name] = selector.replace("meta[", "").replace("]", "").split("=");
        el.setAttribute(tag.replace(/[[\]"]/g, ""), name?.replace(/["]/g, ""));
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    if (title) document.title = title;
    const upsert = (attr, key, value) => {
      if (!value) return;
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", value);
    };

    upsert("name", "description", description);
    upsert("property", "og:title", title);
    upsert("property", "og:description", description);
    upsert("property", "og:image", image);
    upsert("property", "og:url", url || window.location.href);
    upsert("property", "og:type", type);
    upsert("property", "og:site_name", "ITTV News");
    upsert("name", "twitter:card", "summary_large_image");
    upsert("name", "twitter:title", title);
    upsert("name", "twitter:description", description);
    upsert("name", "twitter:image", image);

    // Canonical
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonical || url || window.location.href);

    // JSON-LD
    let ld = document.head.querySelector('script[type="application/ld+json"][data-seo]');
    if (jsonLd) {
      if (!ld) {
        ld = document.createElement("script");
        ld.type = "application/ld+json";
        ld.setAttribute("data-seo", "true");
        document.head.appendChild(ld);
      }
      ld.textContent = JSON.stringify(jsonLd);
    } else if (ld) {
      ld.remove();
    }
  }, [title, description, image, url, type, canonical, jsonLd]);

  return null;
}
